import 'react-image-gallery/styles/css/image-gallery.css'

import { Container, Content, GlobalStyle } from './Layout.style'
import React, { ReactNode } from 'react'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import Navigation from '~/components/Navigation'
import { ThemeProvider } from 'styled-components'
import theme from '~/styles/theme'

type Props = {
    children: ReactNode
    location: Location
}

export default ({ children, location }: Props) => {
    const activeTheme = theme()
    return (
        <MuiThemeProvider theme={activeTheme}>
            <ThemeProvider theme={activeTheme}>
                <>
                    <CssBaseline />
                    <GlobalStyle />
                    <Container>
                        <Navigation location={location} />
                        <Content>{children}</Content>
                    </Container>
                </>
            </ThemeProvider>
        </MuiThemeProvider>
    )
}
